export default __webpack_public_path__ + "static/media/sandal3.805fff28.jpeg";